export const countryCode = {
  'MX': '+52',
  'BR': '+55',
  'JP': '+81',
  'CR': '+506',
  'CO': '+57',
  'CL': '+56',
  'DO': '+1',
  'PE': '+51'
}
